export function getKaraokeQueueItemStage(runtimeState = {}, queueItemId) {
  const normalizedQueueItemId = Number(queueItemId) || null;
  if (!normalizedQueueItemId) return 'queued';
  if (Number(runtimeState.activeQueueItemId) === normalizedQueueItemId) return 'performing';
  if (Number(runtimeState.pendingQueueItemId) === normalizedQueueItemId) return 'pending';
  if (Number(runtimeState.preloadedQueueItemId) === normalizedQueueItemId) return 'prepared';
  return 'queued';
}
